import { render, staticRenderFns } from "./ClientItemEdit.vue?vue&type=template&id=b736f7c8"
import script from "./ClientItemEdit.vue?vue&type=script&lang=js"
export * from "./ClientItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports